/**
 * 分校配置数据查询
 */
export default async function ({
  store,
  app,
}) {
  await store.dispatch('schoolConfig/requerySchoolData', { axios: app.$axios, schoolCode: store.state.schoolCode })
}
